import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const ProfilePage = withSuspense(
	lazy(async () => await import('./profile-page.component')),
	PageLoader,
);
